var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "custom-html-icon-div", style: { background: _vm.color } },
      [
        _vm.markerImg
          ? _c("img", {
              staticClass: "custom-html-icon-img",
              attrs: { alt: "Map marker icon", src: _vm.markerImg }
            })
          : _vm.markerNumber
          ? _c(
              "div",
              {
                staticClass: "custom-html-icon-txt",
                class: {
                  "double-digit-text": _vm.doubleDigitText,
                  "triple-digit-text": _vm.tripleDigitText,
                  "four-digit-text": _vm.fourDigitText
                }
              },
              [_vm._v(_vm._s(_vm.markerNumber) + " ")]
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a95d67d", { render: render, staticRenderFns: staticRenderFns })
  }
}